export const updateDebounces = {}
export const sendDebounces = {}

export function hasPendingDraftWork() {
  return (
    Object.keys(updateDebounces).length > 0 ||
    Object.keys(sendDebounces).length > 0
  )
}
